import React, { useEffect, useMemo, useState } from "react";
import { Row, Col } from "react-bootstrap";
import ProfileInfo from "../components/profile-image/ProfileInfo";
import CustomMenu from "../../../../../../../../shared/components/CustomMenu/CustomMenu";
import { useHistory, useLocation } from "react-router-dom";
import { useAppUser } from "../../../../../../../../contexts/user-context/UserContext";
import { useFirestore } from "reactfire";
import "./styles.scss";
import { useAppContext } from "../../../../../../../../contexts/app-context/AppContext";
import { DashboardAccountsPages } from "../../../../../../containers/account/containers/Account";
import { usePermission } from "../../../../../../../../shared/hooks/usePermission";
import { UserPrivilege } from "../../../../../../../../shared/constants/Constant";

interface Team {
  teamId: string;
  teamName: string;
}

const SubMenuAccount = () => {
  const { push } = useHistory();
  const { pathname } = useLocation();
  const appUser = useAppUser();
  const app = useAppContext();
  const teamProgressPermission = usePermission(UserPrivilege.TEAM);

  const getMenuData = useMemo(() => {
    const data = [];
    if (appUser.userRole.isMember) {
      data.push({
        onClick: () => push(DashboardAccountsPages.ACCOUNT),
        text: "Profile Information",
        isActive: pathname === DashboardAccountsPages.ACCOUNT,
      });
    }

    if (appUser.userRole.isAdmin)
      data.push({
        onClick: () => push(DashboardAccountsPages.CREATE_ADMIN_ACCOUNT),
        text: "Create an admin account",
      });

    if (appUser.userRole.isModerator)
      data.push({
        onClick: () => push(DashboardAccountsPages.CREATE_MODERATOR_ACCOUNT),
        text: "Create a moderator account",
      });

    if (appUser.userRole.isAdmin || appUser.userRole.isModerator)
      data.push({
        onClick: () => push(DashboardAccountsPages.CREATE_MEMBER_ACCOUNT),
        text: "Create a member account",
      });

    if (!appUser.userRole.isModerator && appUser.memberId)
      data.push({
        onClick: () => {
          app.pushBackURL("/dashboard/account");
          push("/dashboard/account/members/" + appUser.memberId);
        },
        text: "My progress",
        isActive: pathname.includes("/dashboard/account/members/"),
      });

    if (
      teamProgressPermission &&
      !appUser.userRole.isModerator &&
      appUser.teamIds &&
      appUser.teamIds.length > 0
    )
      data.push({
        onClick: () => {},
        text: appUser.teamIds?.length > 1 ? "My Teams" : "My Team",
        expandableData: <TeamsMenu />,
        isActive: pathname.includes("/dashboard/account/teams/"),
      });

    return data;
  }, [app, appUser, pathname, push, teamProgressPermission]);

  return (
    <>
      <Row>
        <Col xs={12}>
          <ProfileInfo />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <CustomMenu data={getMenuData} expandable={true} />
        </Col>
      </Row>
    </>
  );
};

const TeamsMenu = () => {
  const [myTeamDetails, setMyTeamDetails] = useState<Team[]>([]);
  const store = useFirestore();
  const appUser = useAppUser();

  useEffect(() => {
    setMyTeamDetails([]);
    if (appUser.teamIds && appUser.teamIds.length > 0) {
      return store
        .collection("teams")
        .where("active", "==", true)
        .onSnapshot({}, (snapshot) => {
          snapshot
            .docChanges()
            .filter((change) => appUser.teamIds.includes(change.doc.id))
            .forEach((change) => {
              if (change.type === "added") {
                setMyTeamDetails((ps) => {
                  ps.push({
                    teamId: change.doc.id,
                    teamName: change.doc.data().name,
                  });
                  return Object.assign([], ps);
                });
              }
              if (change.type === "modified") {
                setMyTeamDetails((ps) => {
                  const modified = ps.map((a) => {
                    if (a.teamId === change.doc.id) {
                      return {
                        teamId: change.doc.id,
                        teamName: change.doc.data().name,
                      };
                    } else {
                      return a;
                    }
                  });
                  return Object.assign([], modified);
                });
              }
              if (change.type === "removed") {
                setMyTeamDetails((ps) => {
                  const removed = ps.filter((a) => a.teamId !== change.doc.id);
                  return Object.assign([], removed);
                });
              }
            });
        });
    }
  }, [store, appUser.teamIds]);

  return (
    <div className="xxmyteams-menu-wrapper">
      <ul>
        {myTeamDetails.map((team, index) => (
          <TeamMenuItem
            key={index}
            teamName={team.teamName}
            teamId={team.teamId}
          />
        ))}
      </ul>
    </div>
  );
};

const TeamMenuItem = (team: Team) => {
  const { push } = useHistory();
  const app = useAppContext();
  const { pathname } = useLocation();
  return (
    <li
      style={
        pathname.includes(team.teamId) ? { backgroundColor: "#003d5c" } : {}
      }
      onClick={() => {
        app.pushBackURL("/dashboard/account");
        push(`/dashboard/account/teams/${team.teamId}`);
      }}
    >
      <div className="team-name">{team.teamName}</div>
    </li>
  );
};

export default SubMenuAccount;
